/**
 *  Filename ....: newmessage.component.ts
 *  Created by ..: ianday
 *  on Date .....: 1/10/24
 **/
import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import { DwUtils } from "../../../../../components/utils/dw-utils";
import { MatTableDataSource } from "@angular/material/table";
import { MessageDefinition } from "../../../../../models/message-definition";
import { MessageDefinitionService } from "../../../../../services/messages.service";
import { Settings } from "../../../../../services/settings";
import { ServiceRequestsService } from "../../../../../services/service-requests.service";
import { MailOption } from "../../../../../models/mail-option";
import { NewMessageHelper } from "./newmessage-helper";
import { MessagesSent } from "../../../../../models/messages-sent";
import { ServiceDefService } from "../../../../../services/servicedef.service";
import { ServiceDef } from "../../../../../models/service-def";
import { MessageSuffix } from 'src/app/models/message-suffix';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'app-newmessage',
	templateUrl: './newmessage.component.html',
	styleUrls: ['./newmessage.component.css']
})

export class NewMessageComponent implements OnInit {

	public strErr: string = '';
	public strDlgErr: string = '';
	public selectedRecord: any;
	public _selectedRequest: any;
	public selectedServiceDef: ServiceDef;

	public displayedColumns: any = ['id','messageCategory', 'subject'];
	public dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

	public recipients: any;
	public selectedCase: any;
	public records: any;

	public Idx: number = -1;
	public busyCursor: boolean = false;
	public caseId: number | null;
	public agencyId: number | null;
	public agencyName: string | null;
	public messageBody: string;
	public editEnabled: boolean;
	public subject: string;
	public sendTo: string;
	public sendCc: string;
	public includeUserTo: boolean;
	public includeUserCc: boolean;
	public includeAgencyAdminCc: boolean;

	public usersEmailAddress: string;
	public agencyAdminEmail: string;
	public helper: NewMessageHelper;
	public mailOption: MailOption;
	public loggedInUser: any;
	public selectedMessageSuffix: MessageSuffix;

	public personalizeDlg: boolean = false;
	public messageSentVisible = false;
	isSubmitting = false;

	public textValHistory: string;
	_tableName: string;

	@Input() set selectedRequest(val: any) {
		this._selectedRequest = val;
	}
	get selectedRequest(): any {
		return this._selectedRequest;
	}
	@Input() set tableName(val: string) {

		if (val !== undefined) {
			this._tableName = val;
		}
	}
	@Output() cancelClicked: EventEmitter<any> = new EventEmitter();
	@Output() submitClicked: EventEmitter<any> = new EventEmitter<any>();

	constructor(public messagesService: MessageDefinitionService,
		public serviceDefService: ServiceDefService,
		public serviceRequestService: ServiceRequestsService) {


	}
	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		if (event.direction === 'asc') {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}

		this.dataSource.data = this.records;
		this.selectRow();
	}
	ngOnInit() {

	}
	public initializeRecord(): void {
		this.sendTo = '';
		this.sendCc = '';
		this.subject = '';
		this.Idx = -1;
		this.messageBody = '';
		this.sendTo = '';
		this.sendCc = '';
		this.includeUserTo = false;
		this.includeUserCc = false;
		this.includeAgencyAdminCc = false;

		/** from the constructor **/
		this.loggedInUser = Settings.getInstance().loggedInUser;
		this.usersEmailAddress = this.loggedInUser.email;
		this.agencyId = this.loggedInUser.agencyId;
		this.agencyName = Settings.getInstance().agencyList.find(s => s.id === this.loggedInUser.agencyId).agencyName;
		this.helper = new NewMessageHelper(this.messagesService, this.serviceDefService, this.serviceRequestService, this.loggedInUser.agencyId);

		this.fetchServiceDefRecord();
	}
	public fetchServiceDefRecord(): void {


		this.selectedServiceDef = new ServiceDef();
		this.selectedMessageSuffix = null;

		/** Note if we are calling this method from the Clients / Cases workspace
		 * We will not be at the request level so ... we will just query records...
		 ***/
		if (this.selectedRequest.serviceDefId === undefined) {
			this.queryRecords();
		}
		else {
			forkJoin([this.serviceDefService.getServiceDefById(this.selectedRequest.serviceDefId),
				this.messagesService.getMessageSuffixByServiceDefIdAndRequestStatusId(this.selectedRequest.serviceDefId, this.selectedRequest.requestStatusId)
			]).subscribe(
				(result: any[]) => {
					if (result && result.length > 0) {
						this.selectedServiceDef = result[0];
					}
					if (result && result.length > 1) {
						this.selectedMessageSuffix = result[1];
					}
					this.queryRecords();
				},
				(error) => {
					Settings.getInstance().handleError('Error: unable to retrieve message suffix data from the' +
						' service');
				}
			);
		}
	}
	public doShowHandler(caseId: number): void {

		this.editEnabled = false;
		this.caseId = caseId;
		this.initializeRecord();
		try {
			this.agencyAdminEmail = Settings.getInstance().getAgencyEmail(this.loggedInUser.agencyId);
		}
		catch {
			this.agencyAdminEmail = '';
		}
	}
	public queryRecords(): void {
		this.busyCursor = true;

		this.messagesService.getAllActiveMessageDefinitions().subscribe(
			(results) => {
				this.busyCursor = false;
				this.records = results;
				if (this._tableName === 'Cases') {
					 this.records = results.filter(record => record.messageCategory !== 'Request');
				}
				this.dataSource = new MatTableDataSource(this.records);
				this.queryCase();
			},
			(error) => {
				this.busyCursor = false;
				Settings.getInstance().handleError(error, 'fetching active message definitions');

			});
	}
	public queryCase(): void {

		if ((this.caseId === undefined) || (this.caseId === null) || this.caseId === 0) {
			return;
		}
		this.busyCursor = true;

		this.serviceRequestService.getCaseById(this.caseId).subscribe(
			(result) => {
				this.busyCursor = false;
				if (result === null) {
					return;
				}
				this.selectedCase = result;

				if (this.selectedCase === undefined) {
					return;
				}

				if (this.selectedCase.email.length > 0) {
					this.sendTo = this.selectedCase.email;
				}
				this.helper.setRecords(this.selectedCase, this.selectedRequest);
			},
			(error) => {
				this.busyCursor = false;
				Settings.getInstance().handleError(error, 'fetching the case');
			}
		)
	}
	public applyFilter(filterValue: any): void {
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.Idx = -1;
		this.editEnabled = false;
		this.unSelectRow();
	}
	public onRowClicked(selected: any) {
		this.editEnabled = true;
		this.selectedRecord = selected;

		this.displayDetail();
		this.selectRow();

	}
	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.displayDetail();

			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.displayDetail();
			}
		}
	}
	public selectRow() {
		if (!this.selectedRecord || this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public unSelectRow() {
		this.Idx = -1;
		this.selectedRecord = new MessageDefinition();
		this.displayDetail();
	}
	public displayDetail(): void {
		this.subject = this.selectedRecord.subject;
        let mailBody: string = this.selectedRecord.messageBody;
        if(mailBody.indexOf("~EMAIL_SUFFIX~") != -1) {
			if(this.selectedMessageSuffix) {
				let mailSuffix = this.helper.parseMessageBody(this.selectedMessageSuffix.messageSuffix);
				mailBody = mailBody.replaceAll("~EMAIL_SUFFIX~", mailSuffix);
			} else {
				mailBody = mailBody.replaceAll("~EMAIL_SUFFIX~", "");
			}
		}
		this.messageBody = this.helper.parseMessageBody(mailBody);
	}
	public doKeyDownEnter(event: any): void {

		event.stopPropagation();

		const inputElement = document.getElementById('messageBodyEditable');
		let enterEvent = new KeyboardEvent("keydown", {
			key: "Enter",
			shiftKey: true,
			keyCode: 13,
			which: 13
		});

		inputElement.dispatchEvent(enterEvent);
	}
	public doIncludeTo(event: any): void {

		if (event.checked === true) {
			if (this.sendTo.length > 0) {
				this.sendTo += '; ' + this.usersEmailAddress;
			} else {
				this.sendTo = this.usersEmailAddress;
			}
		}
		else {
			const to =
				this.sendTo.replace(this.usersEmailAddress, '');
			this.sendTo = to;
		}

	}
	public doIncludeCc(event: any): void {

		if (event.checked === true) {
			if (this.sendCc.length > 0) {
				this.sendCc += '; ' + this.usersEmailAddress;
			} else {
				this.sendCc = this.usersEmailAddress;
			}
		}
		else {
			const cc =
				this.sendCc.replace(this.usersEmailAddress, '');
			this.sendCc = cc;
		}
	}
	public doIncludeAgencyAdminCc(event: any): void {

		if (event.checked === true) {
			if (this.sendCc.length > 0) {
				this.sendCc += '; ' + this.agencyAdminEmail;
			} else {
				this.sendCc = this.agencyAdminEmail;
			}
		}
		else {
			const cc =
				this.sendCc.replace(this.agencyAdminEmail, '');
			this.sendCc = cc;
		}
	}
	public submitRecord(): void {

		this.strErr = '';

		if (this.subject.length === 0) {
			this.strErr = 'Error: A subject line is required';
			DwUtils.setFocus('subjectId');
			return;
		}
		if (this.sendTo.length === 0) {
			this.strErr = "Error: At least one recipient is required";
			DwUtils.setFocus('sendToId');
			return;
		}

		if (!DwUtils.checkMultipleEmailAddresses(this.sendTo)) {
			this.strErr = "Error: Malformed email addresses- use semi-colon to separate";
			DwUtils.setFocus('sendToId');
			return;
		}
		if (!DwUtils.checkMultipleEmailAddresses(this.sendCc)) {
			this.strErr = "Error: Malformed email addresses- use semi-colon to separate";
			DwUtils.setFocus('sendCcId');
			return;
		}

		this.mailOption = new MailOption();
		this.mailOption.setMailOption(this.sendTo, this.sendCc, this.subject, this.messageBody);
		this.editEnabled = false;
		this.messageSentVisible = true;
		this.isSubmitting = true;

		this.messagesService.sendMessage(this.mailOption).subscribe(
			(result) => {
				this.createMessageSentRecord();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'attempting to send a message');
				this.editEnabled = true;
				this.isSubmitting = false;
			});

	}
	public doPersonalizeMessage(): void {
		this.personalizeDlg = true;
		this.textValHistory = this.messageBody;
	}
	public doSubmitPersonalizeMessage(): void {

		if (this.messageBody.length <= 5) {
			this.strDlgErr = 'Error: The message cannot be empty';
			return;
		}

		this.personalizeDlg = false;
	}
	public doCancelPersonalizeMessage(): void {
		this.personalizeDlg = false;
		this.messageBody = this.textValHistory;
	}
	public createMessageSentRecord(): void {

		let msgSent: MessagesSent = new MessagesSent();
		let id = 0;
		/** make sure we have the right ID **/
		if(this._tableName === "ServiceRequests") {
			id = this.selectedRequest.id;
		}
		else {
			id = this.caseId;
		}
		msgSent.setMessageSent(id, this.selectedRecord.id,
			this.agencyId, this.agencyName, this._tableName);

		msgSent.sentBy = this.loggedInUser.username;
		msgSent.sentTo = this.sendTo;
		msgSent.sentCc = this.sendCc;
		msgSent.subject = this.subject;
		msgSent.messageBody = this.messageBody;

		this.messagesService.createMessageSent(msgSent).subscribe(
			(result) => {
				/** all done **/
				setTimeout(() => {
					this.messageSentVisible = false;
					this.isSubmitting = false;
					this.submitClicked.emit(result);
				}, 1000);

			},
			(error) => {
				Settings.getInstance().handleError(error, 'creating a sent message record');
			});
	}
	public cancelSubmitRecord(): void {
		this.cancelClicked.emit();
	}
}


